import { combineReducers } from 'redux';

import { reducer as details } from './detailsModule';
import stateData from './stateData/stateDataReducer';

export default combineReducers({
	details,
	stateData,
});
